import React, { useEffect, useState } from 'react'
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SideBar } from '../LayoutWrapper/components/SideBar'
import { Footer } from '../LayoutWrapper/components/Main/Footer'
import Modal from '../../components/Modal'
import RouteTracker from '../LayoutWrapper/components/RouteTracker'
import useCurrentWidth from '../../customHooks/resizeWindowHook'
import useFooterHeight from '../../customHooks/footerHeightHook'

const DashboardLayout = () => {
  const isMobile = useCurrentWidth()
  const footerHeight = useFooterHeight()
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { instance } = useMsal()
  const [open, setOpen] = useState(!isMobile)
  const [showLogoutModal, setShowLogoutModal] = useState(false)

  useEffect(() => {
    setOpen(!isMobile)
  }, [isMobile])

  useEffect(() => {
    setShowLogoutModal(false)
    if (isMobile) setOpen(false)
  }, [location])

  const onLogoutAction = (action: string) => {
    if (action === 'logout') {
      instance.logout()
      setShowLogoutModal(false)
    } else {
      setShowLogoutModal(false)
      navigate('/')
    }
  }

  return (
    <>
      <RouteTracker />
      <div className={`flex ${isMobile ? 'mobile flex-col' : ''}`}>
        <AuthenticatedTemplate>
          <div className='navbar-wrapper'>
            <SideBar
              open={open}
              isMobile={isMobile}
              setOpen={setOpen}
              setLogoutModal={() => setShowLogoutModal(true)}
            />
          </div>
        </AuthenticatedTemplate>
        <main
          className="flex-1 bg-gray-100 min-h-screen overflow-x-clip relative"
          style={{ paddingBottom: `${footerHeight + 70}px` }}
        >
          {showLogoutModal && (
            <Modal
              head={t('LOG_OUT.LOG_OUT')}
              text={t('LOG_OUT.ARE_YOU_SURE')}
              confirmText={t('BUTTON.YES')}
              cancelText={t('BUTTON.NO')}
              zIndex={1000}
              onConfirm={() => onLogoutAction('logout')}
              onCancel={() => onLogoutAction('cancel')}
            />
          )}
          <Outlet />
        </main>
        <AuthenticatedTemplate>
          <Footer />
        </AuthenticatedTemplate>
      </div>
    </>
  )
}

export default DashboardLayout
